import { Component, ChangeDetectionStrategy } from '@angular/core';

import { ModalState, ModalSettingsMessage } from './generic-modal.service';

@Component({
    selector: 'ep-modal-message',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './modal-message.component.html'
})
export class ModalMessageComponent {
    options: ModalSettingsMessage;

    constructor(private modalState: ModalState) {
        this.options = modalState.options as ModalSettingsMessage;
    }

    close() {
        this.modalState.modal.dismiss();
    }

    ok() {
        this.modalState.modal.close();
    }
}